export function isActiveDistributorSong(song = {}) {
  const status = song?.status ?? song?.song_status ?? song?.songStatus ?? song?.songalbum_status ?? song?.album_status;
  const isDeleted = song?.is_delete ?? song?.is_deleted ?? song?.isDelete ?? song?.isDeleted ?? song?.songalbum_is_delete;

  const normalizedStatus = status === undefined || status === null || status === ''
    ? true
    : status === 1 || status === '1' || status === 'Active' || status === 'active' || status === true;
  const normalizedDeleted = isDeleted === undefined || isDeleted === null || isDeleted === ''
    ? true
    : isDeleted === 0 || isDeleted === '0' || isDeleted === false;

  return normalizedStatus && normalizedDeleted;
}

export function getDistributorSongId(song = {}) {
  return song?.id || song?.song_id || song?.songId;
}
